import { computed, inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { catchError, finalize, map, of } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { CookieService } from '../../../core/services/cookie/cookie.service';
import { Cookies } from '../../../shared/enums/app.enums';
import { HomePageService } from './home-page-service';
import { DEFAULT_PROFILE_DATA, ProfileCompleteInfo } from '../models/common.models';
import { EventStatus} from '../../details/models/details.model';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ProfileCompletionService {
  private cookieService = inject(CookieService);
  private homePageService = inject(HomePageService);
  private platformId = inject(PLATFORM_ID);

  isBrowser = isPlatformBrowser(this.platformId);
  mybdjobsGId = decodeURIComponent(this.cookieService.getCookie(Cookies.MYBDJOBSGID) ?? '');
  isAccountValid = signal(false);
  isProfileCompletionLoading = signal(true);

 videoCvPercentage = computed(() => {
    const data = this.profileCompletion();
    const total = data.totalVideoResumeQuestions;
    const answered = data.totalAnswerVideoResumeQuestions;

    return total > 0 ? Math.round((answered / total) * 100) : 0;
 })

  editProfilePercentage = computed(() => this.profileCompletion().profileCompletePercentage)

  profileCompletion = this.isBrowser
    ? toSignal(
      this.homePageService.getProfileCompletionCached(this.mybdjobsGId).pipe(
        map((data): ProfileCompleteInfo => {
          const responseType = data.event.eventType;
          this.isAccountValid.set(responseType === EventStatus.Success);
          return responseType === EventStatus.Error
            ? DEFAULT_PROFILE_DATA
            : (data.event.eventData[0].value as ProfileCompleteInfo);
        }),
        catchError(() => {
          this.isAccountValid.set(false);
          return of(DEFAULT_PROFILE_DATA);
        }),
        finalize(() => this.isProfileCompletionLoading.set(false))
      ),
      { initialValue: DEFAULT_PROFILE_DATA }
    )
    : signal(DEFAULT_PROFILE_DATA);
}
